import {apiFormRequest, apiRequest} from "./client";
import type {ReturnOrderProductsResponse} from "./types";

export async function getReturnOrderProducts(orderId: number): Promise<ReturnOrderProductsResponse> {
  return apiRequest<ReturnOrderProductsResponse>(`/returns/orders/${orderId}/products`);
}

export async function submitReturn(form: FormData): Promise<{ok: boolean; message: string}> {
  return apiFormRequest<{ok: boolean; message: string}>("/returns", form);
}
